import * as types from '../constants/ActionTypes'


export default function toasts(state = [], action) {
	switch (action.type) {

		case types.INSERT_TOAST:
			return [...state, action.payload];

		case types.SET_TOASTS:
			return action.payload;

		case types.REMOVE_TOAST:
			return state.filter(p => p._id !== action.payload._id);

		case types.REMOVE_TOAST_BY_INDEX:
			return [
		    ...state.slice(0, action.payload),
		    ...state.slice(action.payload + 1)
			]

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/toasts.js